module.exports = __webpack_public_path__ + "img/portraits_04_V.7eb297b6.webp";